import { Component } from '@angular/core';

import { ScheduleAndTrackComponent } from './schedule-and-track/schedule-and-track.component';
import { VehicleComponent } from './vehicle/vehicle.component';

@Component({
  selector: 'app-configuration',
  imports: [VehicleComponent, ScheduleAndTrackComponent],
  templateUrl: './configuration.component.html'
})
export class ConfigurationComponent {}
